import { useMemo } from 'react';

import { useFetchGUnits } from 'hooks/useFetchGUnits';
import { IUnit } from 'interfaces/IInput';
import { resolveProductionTonneUnit } from 'utils/GUnitFilters';

/**
 * The unit new production steps store as yieldUnit/priceUnit. Null while GUnits
 * load, so a step is never saved with a placeholder unit; once loaded (or if
 * the request fails) it is the Production "t" GUnit or a bare "t" fallback.
 */
export const useProductionTonneUnit = (gOrgId: string | null) => {
  const { data: gUnits, isLoading } = useFetchGUnits(gOrgId);

  const tonneUnit = useMemo(
    (): IUnit | null =>
      isLoading ? null : resolveProductionTonneUnit(gUnits ?? []),
    [gUnits, isLoading]
  );

  return { tonneUnit, isLoading };
};
